import {AfterViewInit, Component, Inject, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {PeriodsService} from '../../../../../shared/services/periods.service';
import {SelectOption, SelectOptions} from '../../../../../shared/interfaces/form';
import {AppState} from '../../../../../shared/store/store';
import {Store} from '@ngrx/store';
import {reportUpdateSettings} from '../../../../../shared/store/report/report.actions';

@Component({
  selector: 'app-chart-settings-dialog',
  templateUrl: './chart-settings-dialog.component.html',
  styleUrls: ['./chart-settings-dialog.component.scss']
})
export class ChartSettingsDialogComponent implements OnInit, AfterViewInit {
  public form: FormGroup = new FormGroup({});
  public groupingOptions: SelectOptions<any, any> = this.periodS.getGrouping();

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: any,
    public readonly dialogRef: MatDialogRef<any>,
    private readonly periodS: PeriodsService,
    private readonly _store: Store<AppState>
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.form.get('groupingBy').setValue(this.data.groupingBy || 'day');
    this.form.enable();
  }

  public groupingValueGetter(option: SelectOption<any, any>): string {
    return option.key;
  }

  public onSubmit(): void {
    this._store.dispatch(reportUpdateSettings({
      settings: { groupingBy: this.form.get('groupingBy').value }
    }));
    this.dialogRef.close();
  }

}
